import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class VoucherService {
  VendorList:any = [];
  controllerRoute = '/api/product/voucher';
  getEventRoute = '/api/user/';
  categorizationdata:any;
  subcategorizationdata:any;
  catagaorydetailfromproduct:any;
  path :any;
  VendorName : any;
  vendorname :any;

  constructor(
    private dataService: DataService) {
  }
 
  vouchsave(search)
        {
            return this.dataService.post('/api/application/saveVoucherDetails' , search).map(response => {
                this.dataService.clearRouteCache(this.getEventRoute);
                return response;
            });
        }

}
